import MdToJSX from 'markdown-to-jsx'
import React, { FC } from 'react'

export type Props = {
  children: string
}

const MarkdownLink = ({ children, ...props }) => (
  <a {...props}>{children}</a>
);

export const Markdown: FC<Props> = function ({ children }) {
  return (
    <MdToJSX
      options={{
        forceBlock: true,
        disableParsingRawHTML: true,
        wrapper: React.Fragment,
        overrides: {
          a: {
            component: MarkdownLink,
            props: {
              target: '_blank',
            },
          },
        }
      }}
    >
      {children}
    </MdToJSX>
  )
}